import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { ApplicationCard } from "@/components/admin/ApplicationCard";
import { reportError } from "@/components/admin/portalUtils";

export default function ApplicationsTab() {
  const { pros, setPros } = useOutletContext();
  const [filter, setFilter] = useState("new");
  const update = async (id, payload) => {
    try { const { data } = await api.patch(`/admin/pro-applications/${id}`, payload);
      setPros((list) => list.map((p) => p.id === id ? data.application : p)); toast.success(payload.status ? `Application marked ${payload.status}.` : "Notes saved."); return true; }
    catch (error) { reportError(error, "Update application"); return false; }
  };
  const visible = pros.filter((p) => (p.status || "new") === filter);
  return <section className="space-y-4" data-testid="pro-applications-list">
    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-green mb-8" data-testid="applications-heading">Professional Applications</h1>
    <div className="flex flex-wrap gap-2" data-testid="pro-filter-tabs">{["new", "approved", "declined"].map((status) => <button key={status} onClick={() => setFilter(status)} className={`text-xs px-3 py-2 border uppercase ${filter === status ? "bg-brand-green text-brand-bone" : "text-brand-green"}`} data-testid={`pro-filter-${status}`}>{status} ({pros.filter((p) => (p.status || "new") === status).length})</button>)}</div>
    {!visible.length && <p className="py-8 text-sm text-brand-ink/60" data-testid="applications-empty">No {filter} applications.</p>}
    {visible.map((p) => <ApplicationCard key={p.id} application={p} onUpdate={update} />)}
  </section>;
}